<template>
  <label
    class="tw-flex tw-items-center tw-space-x-2 tw-cursor-pointer hover:tw-bg-gray-50 tw-p-1 tw-rounded"
    @click.stop
  >
    <FancyCheckbox
      :disabled="!column.getCanHide()"
      type="checkbox"
      :checked="column.getIsVisible()"
      @change="column.getToggleVisibilityHandler()?.($event)"
      class="tw-rounded tw-border-gray-300 tw-text-secondary-500 focus:tw-ring-secondary-500 tw-accent-secondary-500"
      :class="{
        'tw-opacity-50': !column.getCanHide(),
        'tw-cursor-not-allowed': !column.getCanHide(),
      }"
    />
    <span class="tw-text-sm tw-text-gray-700">
      {{ typeof column.columnDef.header === 'string' ? column.columnDef.header : column.id }}
    </span>
  </label>
</template>

<script setup lang="ts" generic="T">
import type { Column } from '@tanstack/vue-table';
import FancyCheckbox from '@/components/shared/fancyTables/FancyCheckbox.vue';

defineProps<{
  column: Column<T, unknown>;
}>();
</script>
